import { render, staticRenderFns } from "./OldReports.vue?vue&type=template&id=6a4072f5&"
import script from "./OldReports.vue?vue&type=script&lang=js&"
export * from "./OldReports.vue?vue&type=script&lang=js&"
import style0 from "./OldReports.vue?vue&type=style&index=0&id=6a4072f5&prod&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports